/**
 * @generated SignedSource<<210d27cdc68a4ccef4f47abadb13c9dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchAtlasProject_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultAtlasProject";
  readonly iconUrl?: string | null | undefined;
  readonly id: string;
  readonly project: {
    readonly key: string;
  } | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"projectTitleMetadata_AtlassianSearchPage">;
  readonly " $fragmentType": "searchAtlasProject_AtlassianSearchPage";
};
export type searchAtlasProject_AtlassianSearchPage$key = {
  readonly " $data"?: searchAtlasProject_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchAtlasProject_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    }
  ],
  "kind": "Fragment",
  "name": "searchAtlasProject_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "projectTitleMetadata_AtlassianSearchPage"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "condition": "includeIconUrl",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    },
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        }
      ]
    }
  ],
  "type": "SearchResultAtlasProject"
};

(node as any).hash = "5648bed532cee859541b1023161a3504";

export default node;
